import { ActionType, ProColumns } from '@ant-design/pro-components';
import { DatePicker, Form, Input } from 'antd';
import BoxContainer from 'base/ui/components/BoxContainer';
import CustomButton from 'base/ui/components/Button';
import { observer } from 'mobx-react';
import { useEffect, useRef, useState } from 'react';
// icons
import CustomSelect from 'base/ui/components/CustomSelect';
import CustomProTable, { tablePagination } from 'base/ui/components/CustomTable';
import { CheckStatus, CloseStatus, Filter, Plus } from 'base/ui/components/Icons';
import PageWrapper from 'pages/Components/PageWrapper';
import { SearchBox, SearchForm, SearchItem } from 'pages/Components/SearchBox';
import { useTranslation } from 'react-i18next';
import { PAGE_SIZE_DEFAULT, SYSTEM_TITLE } from 'utils/constants';
import { SearchModel } from 'pages/model';
import { campaignPresenter, campaignStore, commonPresenter, commonStore } from 'stores/root_store';
import { Link, useNavigate } from 'react-router-dom';
import { ROUTES } from 'base/routes/routes';
import { cloneDeep } from 'lodash';
import { ButtonEdit } from 'pages/Components/FunctionButton';
import { ContentModel } from 'services/Main/campaign_services';
import { checkPermission, useCheckPermission } from 'utils/permissionHelper';
import { dropdownstatus } from 'pages/Components/dataDropDown';
import { CommonModel } from 'services/Main/common_services';
import useDebounce from 'hooks/useDebounce';


// Quản lý nội dung =================================================================================================
const createContentManage = () => {
  return observer(() => {
    // Kiểm tra phân quyền
    useCheckPermission('INDEX');
    //=====================================CHUYỂN NGÔN NGỮ=====================================//
    const { t } = useTranslation();
    document.title = t('page-title.content-manage') + ' - ' + SYSTEM_TITLE;

    const [open, setOpen] = useState({
      openDrawer: false,
      openModal: false,
      openConfirm: false,
    });
    const [form] = Form.useForm();

    // ==================================== STATE ===================================================
    // -----DANH SÁCH COMMON ----------------------------------------------

    //--- DATA TABLE ------------------------------------------------------------
    const [dataPaging, setDataPaging] = useState<SearchModel>({
      paging: {
        pageSize: PAGE_SIZE_DEFAULT,
        pageIndex: 1,
        orderBy: undefined,
        orderByDesc: undefined,
      },
      code: undefined,
      name: undefined,
      actived: undefined,
    });
    // data table báo cáo
    const [dataTable, setDataTable] = useState<ContentModel[]>([]);

    const [listCreateBy, setListCreateBy] = useState<CommonModel[]>([]);
    // ======================================================== function =================================================================
    // ----CÁC HÀM LẤY DATA -------------------------------------------------------------------

    const getDataTable = async (dataSearch: any) => {
      await campaignPresenter.getListContent(campaignStore, dataSearch);
      if (campaignStore.listContent.isSuccess) {
        const dataTemp = cloneDeep(campaignStore.listContent.data);
        setDataTable(dataTemp);
        return dataTemp;
      }
      setDataTable([]);
      return [];
    };


    // Lấy  danh sách người tạo
    const getListCreateBy = async (key = '') => {
      await commonPresenter.getListCreateBy(commonStore, key);
      if (commonStore.commonRespone.isSuccess) {
        setListCreateBy(commonStore.commonRespone.data);
      }
    };
    const searchCreateBy = useDebounce(getListCreateBy, 500);

    // ---------------XỬ LÝ COLUMN VÀ TABLE-----------------------------------------------------------------------------------------------------
    const columns: ProColumns<ContentModel>[] = [
      {
        title: t('zalo-notification.stt'),
        dataIndex: 'stt',
        key: 'stt',
        fixed: 'left',
        width: 50,
        onCell: (_, index) => ({
          className: 'text-center',
        }),
      },
      // Mã nội dung
      {
        title: t('campaign.ma-nd'),
        dataIndex: 'contentCode',
        key: 'contentCode',
        fixed: 'left',
        width: 100,
        onCell: (_, index) => ({
          className: 'text-center',
        }),
        // render: (text, record) => (
        //   <Link
        //     to={ROUTES.CUSTOMER.CONTACT_SEGMENTATION.DETAIL.LINK + `?type=detail&tabId=${record.id}&tabName=${text}`}
        //   >
        //     {text}
        //   </Link>
        // ),
      },
      // Tên nội dung
      {
        title: t('campaign.ten-nd'),
        dataIndex: 'contentName',
        key: 'contentName',
        fixed: 'left',
        width: 450,
        // render: (text, record) => (
        //   <Link
        //     to={
        //       ROUTES.CUSTOMER.CONTACT_SEGMENTATION.DETAIL.LINK +
        //       `?type=detail&tabId=${record.id}&tabName=${record.contentCode}`
        //     }
        //   >
        //     {text}
        //   </Link>
        // ),
      },
      // Trạng thái
      {
        title: t('campaign.status'),
        dataIndex: 'actived',
        key: 'actived',
        width: 70,
        render: (_, record) =>
          record.actived ? (
            <CheckStatus width="14" className="!fill-[#0052cc] block mx-auto" />
          ) : (
            <CloseStatus width="14" className="!fill-red-500 block mx-auto" />
          ),
      },
      // Người tạo
      {
        title: t('campaign.create-by'),
        dataIndex: 'createBy',
        key: 'createBy',
        width: 150,
      },
      //   Ngày tạo
      {
        title: t('campaign.create-date'),
        dataIndex: 'createTime',
        key: 'createTime',
        valueType: 'dateTime',
        fieldProps: {
          format: 'DD/MM/YYYY HH:mm:ss',
        },
        width: 150,
        onCell: (_, index) => ({
          className: 'text-center',
        }),
      },
      // Chức năng
      {
        title: t('Chức năng'),
        dataIndex: 'chucNang',
        key: 'chucNang',
        width: 100,
        render: (_, record) => (
          <div className="flex">
            {checkPermission('EDIT') && (
              <Link to={ROUTES.CAMPAIGN.CONTENT_MANAGE.DETAIL.LINK + record.id}>
                <ButtonEdit />
              </Link>
            )}
          </div>
        ),
      },
    ];

    // show filter form
    const showDrawer = () => {
      setOpen({ ...open, openDrawer: true });
    };
    // close filter form
    const onClose = () => {
      setOpen({ ...open, openDrawer: false });
    };
    // ============================================ XỬ LÝ TABS =========================================

    // ============================================LƯU MẪU BÁO CÁO =========================================
    const tableRef = useRef<ActionType>();


    useEffect(() => {
      searchCreateBy()
    }, [])

    return (
      <PageWrapper
        breadcrumb={[
          {
            text: t('page-title.content-manage'),
          },
        ]}
        extras={
          <>
            {checkPermission('CREATE') && (
              <Link to={ROUTES.CAMPAIGN.CONTENT_MANAGE.CREATE.LINK}>
                <CustomButton type="primary" icon={<Plus className="!fill-white" />}>
                  {t('btn.create')}
                </CustomButton>
              </Link>
            )}
            <CustomButton onClick={showDrawer} type="primary" color="#EFF4F9" className="!px-0 w-8">
              <Filter className="!fill-primary" />
            </CustomButton>
          </>
        }
      >
        {/* Table */}
        <BoxContainer fullHeight>
          <CustomProTable<ContentModel>
            bordered
            columns={columns}
            dataSource={dataTable}
            handleResize={() => { }}
            actionRef={tableRef}
            request={async (params = {}, sort, filter) => {
              const data = await getDataTable({
                ...dataPaging,
                paging: {
                  ...dataPaging.paging,
                  orderBy: Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                  orderByDesc:
                    Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                },
              });

              if (Object.values(sort).length) {
                setDataPaging({
                  ...dataPaging,
                  paging: {
                    ...dataPaging.paging,
                    orderBy:
                      Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                    orderByDesc:
                      Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                  },
                });
              }
              return {
                data: data,
                success: campaignStore.listContent.isSuccess,
              };
            }}
            rowKey="stt"
            pagination={{
              ...tablePagination(dataPaging, setDataPaging),
              total: campaignStore.listContent.paging?.totalCount,
            }}
            options={false}
          />
        </BoxContainer>

        {/* Form search */}
        <SearchBox
          onClose={onClose}
          className="lg:!w-[25%]"
          open={open.openDrawer}
          footer={
            <CustomButton
              htmlType="submit"
              className="my-auto ml-auto"
              type="primary"
              onClick={() => {
                const code = form.getFieldValue('customerSegmentationCode');
                const createTime = form.getFieldValue('createTime');

                setDataPaging({
                  ...form.getFieldsValue(),
                  createTime: createTime?.format("YYYY-MM-DD") || undefined,
                  customerSegmentationCode: Number(code) ? Number(code) : undefined,
                  paging: { ...dataPaging.paging, pageIndex: 1 },
                });
                form.submit();
                tableRef.current?.reload();
                // onClose();
              }}
            >
              {t('btn.search')}
            </CustomButton>
          }
        >
          <SearchForm form={form} column="col-1">
            {/* Phân khúc */}
            <SearchItem name={'code'} label={t('campaign.ma-nd')}>
              <Input />
            </SearchItem>
            {/* tên nội dung */}
            <SearchItem name={'name'} label={t('campaign.ten-nd')}>
              <Input />
            </SearchItem>
            {/* ngày tạo */}
            <SearchItem name={'createTime'} label={t('segment.ngay-tao')}>
              <DatePicker format={'DD/MM/YYYY'} className='!w-full' />
            </SearchItem>
            {/* Người tạo */}
            <SearchItem name={'createBy'} label={t('search-form.created-by')}>
              <CustomSelect
                options={listCreateBy}
                fieldNames={{ label: 'value', value: 'key' }}
                filterOption={false}
                onSearch={(value) => {
                  value ? searchCreateBy(value) : searchCreateBy();
                }}
                onClear={() => searchCreateBy()}
                allowClear
                showSearch
              />
            </SearchItem>
            {/* Trạng thái */}
            <SearchItem name={'actived'} label={t('segment.trang-thai')}>
              <CustomSelect defaultValue={null} options={dropdownstatus} allowClear />
            </SearchItem>
          </SearchForm>
        </SearchBox>
      </PageWrapper>
    );
  });
};

export default createContentManage;
